import React from 'react';

// Summary: Standalone chef-hat glyph (FontAwesome free-solid has no bare chef-hat icon —
// faKitchenSet bundles a whisk with the hat). Sourced from svgrepo.com, filled with the
// tile's tone color via currentColor.
export const ChefHatIcon: React.FC<{ className?: string }> = ({ className }) => (
    <svg className={className} viewBox="0 0 512.001 512.001" width="1em" height="1em" fill="currentColor" aria-hidden="true">
        <rect x="94.475" y="398.636" width="323.05" height="75.231" />
        <path d="M417.522,90.162c-26.722,0-50.835,11.112-68.02,28.946c-6.555-45.778-45.91-80.973-93.501-80.973
			s-86.946,35.194-93.501,80.973c-17.185-17.833-41.298-28.946-68.02-28.946C42.299,90.162,0,132.461,0,184.64
			c0,52.18,42.299,94.478,94.478,94.478v86.124h323.044v-86.125c52.178,0,94.478-42.299,94.478-94.478
			C512.001,132.459,469.701,90.162,417.522,90.162z" />
    </svg>
);
